import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import css from './FieldHelp.module.css';

/**
 * The line under a field, from the Components board: help text, or the error instead of it
 * (never both), or a success note; with an optional counter on the right ("78 / 500"). The field
 * points at it with aria-describedby, using the same `id`.
 */
const FieldHelp = props => {
  const { id, className, helpText, errorText, successText, counter } = props;
  let message = null;
  if (errorText) {
    message = (
      <span id={id} className={css.error}>
        {errorText}
      </span>
    );
  } else if (successText) {
    message = (
      <span id={id} className={css.success}>
        {successText}
      </span>
    );
  } else if (helpText) {
    message = (
      <span id={id} className={css.help}>
        {helpText}
      </span>
    );
  }
  if (!message && counter == null) {
    return null;
  }
  return (
    <div className={classNames(css.root, className)}>
      {message}
      {counter != null ? <span className={css.counter}>{counter}</span> : null}
    </div>
  );
};

FieldHelp.defaultProps = {
  id: null,
  className: null,
  helpText: null,
  errorText: null,
  successText: null,
  counter: null,
};

FieldHelp.propTypes = {
  id: string,
  className: string,
  helpText: node,
  errorText: node,
  successText: node,
  counter: node,
};

export default FieldHelp;
